export const toAddressSearchString = (parts = []) => {
  return parts
    .map((part) => (typeof part === "string" ? part.trim() : ""))
    .filter(Boolean)
    .join(", ");
};

/** Params for taxLookup from a manual venue address (KY V2 + legacy city). */
export const toManualVenueTaxLookup = ({ address, city, state, zip }) => ({
  state,
  city,
  searchString: toAddressSearchString([address, city, state, zip, "US"]),
});

/**
 * Choose municipality after tax lookup. Returns the region's index, so a region
 * with a blank code is still selectable; -1 when the user has to choose.
 * Prefer keeping the previous code when still valid; else city-name match;
 * else the sole region when lookup already resolved one municipality
 * (e.g. Louisville address → Fincastle only).
 */
export const pickMunicipalityIndex = (
  regions = [],
  { city = "", previousCode = "" } = {},
) => {
  const previousIndex = previousCode
    ? regions.findIndex((region) => region.code === previousCode)
    : -1;

  if (previousIndex !== -1) {
    return previousIndex;
  }

  const cityIndex = regions.findIndex(
    (region) => region.name.toLowerCase() === String(city).toLowerCase(),
  );

  if (cityIndex !== -1) {
    return cityIndex;
  }

  return regions.length === 1 ? 0 : -1;
};

/**
 * Edit allowed when municipality code unchanged, or both codes share same tax rate
 * in the current lookup results (e.g. Fincastle ↔ Springmill at 5%).
 */
export const isSameMunicipalityTaxRate = (
  currentCode,
  initialCode,
  taxRegions = [],
) => {
  if (!currentCode || !initialCode) {
    return currentCode === initialCode;
  }
  if (currentCode === initialCode) {
    return true;
  }

  const current = taxRegions.find((region) => region.code === currentCode);
  const initial = taxRegions.find((region) => region.code === initialCode);

  if (current && initial) {
    return Number(current.rate) === Number(initial.rate);
  }

  // Only current region known (initial not in this address's list): compare via
  // premium calc instead — treat as allowed here so canUpdatePolicy can gate.
  if (current && !initial) {
    return true;
  }

  return false;
};
